import { View } from "react-native";
import ProfilePicture from "src/components/ProfilePicture";
import { paddingSmall } from "src/styles/spacing";

const MiniCardUsersPreview = ({ userIds }: { userIds: string[] }) => {
	if (userIds.length === 0) {
		return null;
	} else if (userIds.length === 1) {
		return <ProfilePicture touchable={false} userId={userIds[0]} size={20} />;
	} else if (userIds.length === 2) {
		return (
			<View
				style={{
					width: 52,
					height: 32,
				}}
			>
				<ProfilePicture
					userId={userIds[0]}
					touchable={false}
					size={20}
					style={{
						position: "absolute",
						bottom: paddingSmall,
						left: 12,
					}}
				/>
				<ProfilePicture
					userId={userIds[1]}
					touchable={false}
					size={14}
					style={{
						position: "absolute",
						top: 2,
						right: 4,
					}}
				/>
			</View>
		);
	} else {
		return (
			<View
				style={{
					width: 52,
					height: 32,
				}}
			>
				<ProfilePicture
					userId={userIds[0]}
					touchable={false}
					size={16}
					style={{
						position: "absolute",
						bottom: 2,
						right: 14,
					}}
				/>
				<ProfilePicture
					userId={userIds[1]}
					touchable={false}
					size={14}
					style={{
						position: "absolute",
						top: 8,
						left: 8,
					}}
				/>
				<ProfilePicture
					userId={userIds[2]}
					touchable={false}
					size={10}
					style={{
						position: "absolute",
						top: 4,
						right: 20,
					}}
				/>
			</View>
		);
	}
};
export default MiniCardUsersPreview;
